// One-on-one sessions with Min. Chantal are booked on Calendly
export const CALENDLY_URL = "https://calendly.com/chantalekabe";

// Ministry inbox: contact forms are delivered here
export const MINISTRY_EMAIL = "info@chantalekabeministries.com";
